export enum FeatureState {
  Init = 'Init',
  Loading = 'Loading',
  Success = 'Success',
  Error = 'Error',
}
